import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';

const ContactForm: React.FC = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formState);
  };

  const textFieldStyles = {
    '& .MuiInput-underline:before': { borderBottomColor: 'rgba(184, 197, 184, 0.3)' },
    '& .MuiInput-underline:after': { borderBottomColor: '#B8C5B8' },
    '& .MuiInputBase-input': { color: '#ffffff' },
    '& .MuiInputLabel-root': { color: 'rgba(184, 197, 184, 0.7)', fontWeight: 300 },
    '& .MuiInputLabel-root.Mui-focused': { color: '#B8C5B8' },
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        mt: 0,
        p: { xs: 3, md: 5 },
        background: 'rgba(255, 255, 255, 0.03)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(184, 197, 184, 0.1)',
        transition: 'all 0.3s ease',
        '&:hover': {
          border: '1px solid rgba(184, 197, 184, 0.3)',
        },
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 4,
        }}
      >
        <Box>
          <TextField
            fullWidth
            label="Nombre"
            name="name"
            variant="standard"
            value={formState.name}
            onChange={handleChange}
            sx={textFieldStyles}
          />
        </Box>
        <Box>
          <TextField
            fullWidth
            label="Email Corporativo"
            name="email"
            variant="standard"
            value={formState.email}
            onChange={handleChange}
            sx={textFieldStyles}
          />
        </Box>
        <Box sx={{ gridColumn: { xs: 'span 1', md: 'span 2' } }}>
          <TextField
            fullWidth
            label="Empresa / Organización"
            name="company"
            variant="standard"
            value={formState.company}
            onChange={handleChange}
            sx={textFieldStyles}
          />
        </Box>
        <Box sx={{ gridColumn: { xs: 'span 1', md: 'span 2' } }}>
          <TextField
            fullWidth
            label="¿Cómo podemos potenciar su estrategia legal?"
            name="message"
            multiline
            rows={4}
            variant="standard"
            value={formState.message}
            onChange={handleChange}
            sx={textFieldStyles}
          />
        </Box>
        <Box sx={{ gridColumn: { xs: 'span 1', md: 'span 2' } }}>
          <Button
            type="submit"
            variant="outlined"
            size="large"
            fullWidth
            sx={{
              mt: 2,
              py: 2,
              borderColor: '#B8C5B8',
              color: '#B8C5B8',
              borderRadius: 0,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              transition: 'all 0.3s ease',
              '&:hover': {
                borderColor: '#FFFFFF',
                color: '#FFFFFF',
                backgroundColor: 'rgba(184, 197, 184, 0.1)',
              },
            }}
          >
            Enviar Solicitud
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactForm;
